document.addEventListener('DOMContentLoaded', function () {
  const panel = document.querySelector('.loopi-pdp-purchase-panel');
  const footer = document.querySelector('.footer-content');
  if (!panel) return;

  const mobileMq = window.matchMedia('(max-width: 767px)');

  const spacer = document.createElement('div');
  spacer.className = 'loopi-pdp-purchase-panel-spacer';
  panel.insertAdjacentElement('afterend', spacer);

  let isFixed = false;
  let startStickY = 0;
  let stopStickY = Infinity;

  function getPageTop(el) {
    return el.getBoundingClientRect().top + window.scrollY;
  }

  function setSpacerHeight() {
    spacer.style.height = isFixed ? panel.offsetHeight + 'px' : '0px';
  }

  function recalcThresholds() {
    const wasFixed = isFixed;

    panel.classList.remove('atc--fixed');
    isFixed = false;
    spacer.style.height = '0px';

    const panelTop = getPageTop(panel);
    const panelHeight = panel.offsetHeight;

    startStickY = panelTop + panelHeight;

    if (footer) {
      const footerTop = getPageTop(footer);
      stopStickY = footerTop - window.innerHeight + 24;
    } else {
      stopStickY = Infinity;
    }

    updateSticky();

    if (wasFixed && !isFixed) {
      spacer.style.height = '0px';
    }
  }

  function updateSticky() {
    if (!mobileMq.matches) {
      if (isFixed) {
        panel.classList.remove('atc--fixed');
        isFixed = false;
      }
      spacer.style.height = '0px';
      return;
    }

    const y = window.scrollY;
    const shouldBeFixed = y >= startStickY && y < stopStickY;

    if (shouldBeFixed !== isFixed) {
      isFixed = shouldBeFixed;
      panel.classList.toggle('atc--fixed', shouldBeFixed);
      setSpacerHeight();
    } else if (isFixed) {
      setSpacerHeight();
    }
  }

  let resizeTimer;
  function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      recalcThresholds();
    }, 80);
  }

  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', handleResize);
  window.addEventListener('load', recalcThresholds);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', handleResize);
  }

  recalcThresholds();
});